(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1766],{

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 77479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36745);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MainBlock = function MainBlock(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__/* .MainBlockStyle.block */ .d.block, styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ MainBlockStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);

var MainBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    boxSizing: "border-box"
  }
});

/***/ }),

/***/ 59941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* reexport safe */ _MainBlock__WEBPACK_IMPORTED_MODULE_1__.R; }
/* harmony export */ });
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36745);
/* harmony import */ var _MainBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77479);



/***/ }),

/***/ 84026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ H2; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/H2Style.ts




var H2Style = es/* StyleSheet.create */.mM.create({
  h2: {
    fontSize: typographyStyle/* fontSize.headline */.JB.headline,
    lineHeight: typographyStyle/* lineHeight.headline2 */.Nv.headline2,
    fontWeight: typographyStyle/* fontWeight.regular */.Ue.regular,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    padding: "calc(".concat(spaceStyle/* space.atom */.D.atom, " - (").concat(typographyStyle/* lineHeight.headline2 */.Nv.headline2, " - ").concat(typographyStyle/* fontSize.headline */.JB.headline, ")/2) ").concat(spaceStyle/* space.atom */.D.atom),
    margin: 0
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/H2.tsx




var H2 = function H2(props) {
  var styles = props.styles,
      children = props.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
    className: (0,es/* css */.iv)(H2Style.h2, styles),
    children: children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/index.ts


/***/ }),

/***/ 12160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BasicBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79105);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








var BasicBlockComponent = function BasicBlockComponent(props) {
  var children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "block" : _props$styleKey,
      _props$backgroundStyl = props.backgroundStyleKey,
      backgroundStyleKey = _props$backgroundStyl === void 0 ? "primary" : _props$backgroundStyl;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: [blockStyle[styleKey], backgroundStyle[backgroundStyleKey],  true ? "" : 0,  true ? "" : 0],
    children: children
  });
};

var BasicBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(BasicBlockComponent);
var blockStyle = {
  block: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page1col */ .k.page1col, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockWide: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page1colWide */ .k.page1colWide, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockFullWidth: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " 0;max-width:100%;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockMultiCol: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";margin:0 auto;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page2col */ .k.page2col, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0),
  blockMultiColWide: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";margin:0 auto;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page2colWide */ .k.page2colWide, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0)
};
var backgroundStyle = {
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)( true ? "" : 0,  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, -2), ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 26079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


var _excluded = ["backgroundStyleKey", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var MainBlock = function MainBlock(props) {
  var _props$backgroundStyl = props.backgroundStyleKey,
      backgroundStyleKey = _props$backgroundStyl === void 0 ? "primary" : _props$backgroundStyl,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: [blockStyle, backgroundStyle[backgroundStyleKey],  true ? "" : 0,  true ? "" : 0]
  }, rest), {}, {
    children: children
  }));
};
var blockStyle =  true ? {
  name: "1khn195",
  styles: "box-sizing:border-box"
} : 0;
var backgroundStyle = {
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)( true ? "" : 0,  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 99581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Breadcrumb/BreadcrumbStyle.ts




var BreadcrumbStyle = es/* StyleSheet.create */.mM.create({
  ul: {
    listStyleType: "none",
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom0_5x */.D.atom0_5x)
  },
  list: {
    display: "inline-block",
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption3 */.Nv.caption3,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    marginBottom: spaceStyle/* space.atom0_5x */.D.atom0_5x,
    ":after": {
      content: '"/"',
      color: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor,
      padding: "0 ".concat(spaceStyle/* space.atom */.D.atom),
      opacity: 0.7
    },
    ":last-child": {
      ":after": {
        content: "none"
      }
    }
  },
  span: {
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    textDecoration: "none"
  },
  link: {
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    transition: "color 0.4s ease",
    ":hover": {
      color: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Breadcrumb/Breadcrumb.tsx




var Breadcrumb = function Breadcrumb(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    className: (0,es/* css */.iv)(BreadcrumbStyle.ul),
    children: props.linkData.map(function (data, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: (0,es/* css */.iv)(BreadcrumbStyle.list),
        children: data.url ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: data.url,
          className: (0,es/* css */.iv)(BreadcrumbStyle.link),
          children: data.label
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          className: (0,es/* css */.iv)(BreadcrumbStyle.span),
          children: data.label
        })
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Breadcrumb/index.ts


/***/ }),

/***/ 7696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BlockTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/H2/index.ts + 2 modules
var H2 = __webpack_require__(84026);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/BlockTitleStyle.ts






var BlockTitleStyle = es/* StyleSheet.create */.mM.create({
  block: {
    padding: spaceStyle/* space.atom */.D.atom
  },
  title: (0,defineProperty/* default */.Z)({
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading,
    lineHeight: typographyStyle/* lineHeight.headline1 */.Nv.headline1,
    color: colorStyle/* accentColor.secondaryColor2 */.z.secondaryColor2,
    padding: spaceStyle/* space.atom */.D.atom,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    letterSpacing: "0.1em",
    margin: "0.5rem 0",
    position: "relative",
    paddingBottom: spaceStyle/* space.atom2x */.D.atom2x,
    ":before": {
      content: "''",
      position: "absolute",
      bottom: 0,
      display: "block",
      height: "1px",
      width: "calc(100% - ".concat(spaceStyle/* space.atom2x */.D.atom2x, ")"),
      background: colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor
    },
    ":after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      display: "block",
      height: "1px",
      width: "3rem",
      background: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    fontSize: typographyStyle/* fontSize.headline */.JB.headline
  })
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/BlockTitle.tsx




var BlockTitle = function BlockTitle(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H2.H2, {
    styles: [BlockTitleStyle.title, props.styles],
    children: props.children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/index.ts


/***/ }),

/***/ 93478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ RegionList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/RegionList/RegionListStyle.ts


var _list;






var RegionListStyle = es/* StyleSheet.create */.mM.create({
  block: {
    padding: spaceStyle/* space.atom */.D.atom,
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none"
  },
  list: (_list = {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption3 */.Nv.caption3,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom2x */.D.atom2x),
    marginBottom: spaceStyle/* space.atom0_5x */.D.atom0_5x,
    letterSpacing: "0.1em",
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    ":before": {
      content: "''",
      position: "absolute",
      top: "1rem",
      left: 0,
      display: "block",
      height: "1px",
      width: spaceStyle/* space.atom */.D.atom,
      background: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor
    }
  }, (0,defineProperty/* default */.Z)(_list, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    width: "50%"
  }), (0,defineProperty/* default */.Z)(_list, (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), {
    width: "25%"
  }), _list),
  link: {
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    textDecoration: "none",
    transition: "color 0.4s ease",
    ":hover": {
      color: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/RegionList/RegionList.tsx




var RegionList = function RegionList(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    className: (0,es/* css */.iv)(RegionListStyle.block),
    children: props.regions.map(function (region, index) {
      var region_path = region.code || region.id;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: (0,es/* css */.iv)(RegionListStyle.list),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          className: (0,es/* css */.iv)(RegionListStyle.link),
          href: "".concat(props.linkUrl).concat(region_path),
          children: region.name
        })
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/RegionList/index.ts


/***/ }),

/***/ 87687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ PostTrackingLinkDomains; },
/* harmony export */   "YF": function() { return /* binding */ POST_SLUG; },
/* harmony export */   "fy": function() { return /* binding */ PostSearchGAParams; }
/* harmony export */ });
/* unused harmony export LINE_ADD_FRIEND_URL */
var POST_SLUG =  false ? 0 : "posts";
var LINE_ADD_FRIEND_URL = "https://lin.ee/tlg2Tnc";
var PostSearchGAParams = {
  utm_campaign: "line_ta1",
  utm_medium: "organic",
  utm_source: "tarip"
};
var PostTrackingLinkDomains = ["liff.line.me"];

/***/ }),

/***/ 30522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useUserAccount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95094);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39666);
/* harmony import */ var main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12297);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94265);






 // useAccountのredux toolkit版
// liff.initをここですると、同一ページでLiffTypesが違うところから来ると不整合が出るのでしない。必要なところでinitする

var useUserAccount = function useUserAccount(store) {
  var enableSocialSignedInCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var loadAccount = function loadAccount() {
    return store.dispatch((0,main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_2__/* .fetchAccountParams */ .Nv)({
      param: ""
    })).then(_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .unwrapResult */ .SI).then(function (result) {
      var accountParams = result;

      if (accountParams) {
        // 取得したデータを各reducerで直接保存しているため
        // 以前のinitCurrentUser/initAccountParamsは不要
        if (enableSocialSignedInCheck) {
          checkInitializedSocial(accountParams.facebookAppId);
        }
      }
    });
  };

  var checkLIFFState = function checkLIFFState() {
    try {
      var _liff;

      var context = (_liff = liff) === null || _liff === void 0 ? void 0 : _liff.getOS();

      if (context) {
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__/* .setIsLIFFInitialized */ .hV)(true));
      }

      if (liff.id && liff.isLoggedIn()) {
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__/* .setIsLIFFLoggedIn */ .ux)(true));
      }
    } catch (_unused) {// do nothing
    }
  };

  var onLoadScriptLIFF = function onLoadScriptLIFF() {
    checkLIFFState();
  };

  var loadScript = function loadScript(url, onload) {
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = onload ? onload : null;
    document.body.appendChild(script);
  };

  var checkInitializedSocial = function checkInitializedSocial(facebookAppId) {
    if (typeof liff !== "undefined") {
      checkLIFFState();
    } else {
      loadScript(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_3__/* .LINE_LIFF_SDK_URL */ .i3, onLoadScriptLIFF);
    } // FacebookMessengerは現在使用していない


    if (facebookAppId) {//   (window as any).MessengerExtensions?.getContext(
      //     facebookAppId,
      //     (): void => {
      //       store.dispatch(setIsFacebookMessengerInitialized(true));
      //     },
      //     (err: any): void => {
      //       console.log("FBM ERROR ", err);
      //     }
      //   );
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.isReady) {
      loadAccount()["catch"](function (e) {
        console.error(e);

        if (true) {
          _sentry_node__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(e.errorMessages || e);
        }
      });
    }
  }, [router.isReady]);
  return;
};

/***/ }),

/***/ 77562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ rangexy; }
/* harmony export */ });
function rangexy(start, end) {
  return Array.from({
    length: end - start
  }, function (_, k) {
    return k + start;
  });
}

/***/ }),

/***/ 76438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _regionId_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider = __webpack_require__(6339);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/containers/organisms/Header/HeaderContainer.ts
var HeaderContainer = __webpack_require__(12664);
// EXTERNAL MODULE: ./main/javascripts/styles/globalStyle.ts
var globalStyle = __webpack_require__(15305);
// EXTERNAL MODULE: ./i18n.ts + 313 modules
var i18n = __webpack_require__(44349);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/components/head/MainHead.tsx + 2 modules
var MainHead = __webpack_require__(65025);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useConstructor.ts
var useConstructor = __webpack_require__(83795);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useUserAccount.tsx
var useUserAccount = __webpack_require__(30522);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Block/MainBlock/index.ts
var MainBlock = __webpack_require__(59941);
// EXTERNAL MODULE: ./main/javascripts/components/search/SearchBlock.tsx
var SearchBlock = __webpack_require__(44112);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightTravelerBlock.tsx
var FlightTravelerBlock = __webpack_require__(90652);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightOriginDestinationDate.tsx + 12 modules
var FlightOriginDestinationDate = __webpack_require__(46385);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/FlightTypeBlock.tsx
var FlightTypeBlock = __webpack_require__(28090);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/constants/SearchCategories.ts
var SearchCategories = __webpack_require__(80264);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/constants/FlightTypes.ts
var FlightTypes = __webpack_require__(45021);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/CabinClassBlock.tsx
var CabinClassBlock = __webpack_require__(84077);
// EXTERNAL MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx + 2 modules
var FormErrorsBlock = __webpack_require__(59557);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSuggestionSlice.ts
var flightSuggestionSlice = __webpack_require__(59960);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/features/lp/flightDstRegion/lpFlightDstRegionSlice.ts
var lpFlightDstRegionSlice = __webpack_require__(95698);
// EXTERNAL MODULE: ./main/javascripts/features/flight/searchFlightSlice.ts + 1 modules
var searchFlightSlice = __webpack_require__(71900);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/utils/FormUtil.ts
var FormUtil = __webpack_require__(63591);
// EXTERNAL MODULE: ./main/javascripts/constants/PostConstants.ts
var PostConstants = __webpack_require__(87687);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/flightDstRegion/components/SearchFlight.tsx




var _excluded = ["text"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


































yup_es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = yup_es/* object */.Ry().shape({
  origin: yup_es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: yup_es/* string */.Z_().nullable().required()
  }),
  origin_id: yup_es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: yup_es/* number */.Rx().nullable().required()
  }),
  destination: yup_es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: yup_es/* string */.Z_().nullable().required()
  }),
  destination_id: yup_es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: yup_es/* number */.Rx().nullable().required()
  }),
  departure_date: yup_es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: yup_es/* string */.Z_().nullable().required()
  }),
  return_date: yup_es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.roundTrip */.z.roundTrip;
    },
    then: yup_es/* string */.Z_().nullable().required()
  }),
  itineraries: yup_es/* array */.IX().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: function then(schema) {
      return schema.of(yup_es/* object */.Ry().shape({
        origin: yup_es/* string */.Z_().required(),
        origin_id: yup_es/* number */.Rx().required(),
        destination: yup_es/* string */.Z_().required(),
        destination_id: yup_es/* number */.Rx().required(),
        departure_date: yup_es/* string */.Z_().nullable().required()
      }));
    }
  }),
  traveler: yup_es/* object */.Ry().shape({
    number_of_children: yup_es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: yup_es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
        age: yup_es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required().test("infantsNumber", "infantsNumber", function (value, context) {
          var _parent2$value, _parent2$value2;

          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          var _context$from = (0,slicedToArray/* default */.Z)(context.from, 2),
              _ = _context$from[0],
              parent2 = _context$from[1];

          var infantsNumber = ((parent2 === null || parent2 === void 0 ? void 0 : (_parent2$value = parent2.value) === null || _parent2$value === void 0 ? void 0 : _parent2$value.ages_of_children) || []).filter(function (age) {
            // 空文字を無視したいためparseIntを使用
            return parseInt(age.age) <= 1;
          }).length;
          var adultsNumber = Number((parent2 === null || parent2 === void 0 ? void 0 : (_parent2$value2 = parent2.value) === null || _parent2$value2 === void 0 ? void 0 : _parent2$value2.number_of_adult) || 1);
          return infantsNumber <= adultsNumber;
        })
      }))
    })
  })
});
var defaultValues = {
  departure_date: null,
  // undefinedではダメ
  return_date: null,
  // undefinedではダメ
  traveler: {
    number_of_adult: 2,
    number_of_children: 0
  },
  access_type: "direct_web",
  flight_type: (0,humps.decamelize)("roundTrip"),
  cabin_class: "Y",
  itineraries: [{
    departure_date: null
  }, {
    departure_date: null
  }]
};
var SearchFlight = function SearchFlight() {
  var _region;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var flightDestinationRegion = (0,store/* useAppSelector */.CG)(lpFlightDstRegionSlice/* flightDestinationRegionSelector */.oc);

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var initialValues = {};
  var region = null;

  if (flightDestinationRegion) {
    region = flightDestinationRegion.region;
    var defaultDetionatination = flightDestinationRegion.destinationSuggestions[0];

    if (defaultDetionatination) {
      initialValues.destination_id = defaultDetionatination.id;
      initialValues.destination = defaultDetionatination.name;
      initialValues.destination_type = "region";
    } // const today: Date = new Date();
    // const departureDate: Date = addMonths(today, 2);
    // const dateFormat = "yyyy/LL/dd";
    // initialValues.departure_date = format(departureDate, dateFormat);
    // initialValues.return_date = format(addDays(departureDate, 5), dateFormat);

  }

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: _objectSpread(_objectSpread({}, defaultValues), initialValues)
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              params = (0,searchFlightSlice/* convertSearchFlightFormValuesToParams */.uI)(values);
              return _context.abrupt("return", appDispatch((0,searchFlightSlice/* postSearchFlightCache */.re)({
                params: params
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,googleTagManagerUtil/* flightAvailabilitiesEvent */.t6)(cacheId, params);
                var gaParams = (0,lib.stringify)(PostConstants/* PostSearchGAParams */.fy, {
                  arrayFormat: "indices"
                });
                window.location.href = "".concat(Constants/* TABI_DOMAIN */.xQ, "/flights?").concat((0,lib.stringify)(params, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId, "&").concat(gaParams);
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);

                if (errorResponse.errors) {
                  // エラー形式を合わせるために変換している
                  var _errors = Object.keys(errorResponse.errors).map(function (key) {
                    return (0,defineProperty/* default */.Z)({}, key, errorResponse.errors[key]);
                  });

                  (0,FormUtil/* convertServerErrorToForm */.fz)({
                    fieldMessages: _errors
                  }, setError);
                }
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchFlightDestinationSuggestionsAction = function fetchFlightDestinationSuggestionsAction(data, type, index) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

    appDispatch((0,flightSuggestionSlice/* debouncedFetchFlightDestinationSuggestions */.tk)({
      params: _objectSpread({
        text: text
      }, rest),
      type: type,
      index: index
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
      css: titleStyle,
      children: t("lp.searchFlightByDestinationTitle", {
        destination: ((_region = region) === null || _region === void 0 ? void 0 : _region.name) || ""
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: handleFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: flightTypeBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightTypeBlock/* FlightTypeBlock */.c, {
            labelStyleKey: "labelDark",
            borderColorStyleKey: "secondary"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginDestinationDate/* FlightOriginDestinationDate */.e, {
          destinationSuggestOptions: {},
          defaultDestinations: flightDestinationRegion.destinationSuggestions,
          fetchFlightOriginDestinationSuggestions: fetchFlightDestinationSuggestionsAction,
          useDatePicker: true,
          searchType: SearchCategories/* searchCategories.flight */.M.flight,
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: flightClassBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinClassBlock/* CabinClassBlock */.B, {
            labelColorStyleKey: "default",
            borderColorStyleKey: "secondary"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightTravelerBlock/* FlightTravelerBlock */.Z, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
            namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
            errors: errors,
            hideValidationErrors: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: submitBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            children: "\u691C \u7D22"
          })
        })]
      })
    }))]
  });
};
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";width:50%;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:0 auto;padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:", spaceStyle/* space.atom */.D.atom, " auto ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding:0 ", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";letter-spacing:0.1em;font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.title */.JB.title, ";}" + ( true ? "" : 0),  true ? "" : 0);
var flightTypeBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var flightClassBlockStyle =  true ? {
  name: "11vmki4",
  styles: "width:50%;min-width:200px"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/components/block/MainBlock.tsx
var block_MainBlock = __webpack_require__(26079);
// EXTERNAL MODULE: ./main/javascripts/components/block/BasicBlock.tsx
var BasicBlock = __webpack_require__(12160);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(11640);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./main/javascripts/utils/StringUtil.tsx
var StringUtil = __webpack_require__(56896);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/flightDstRegion/components/FlightReferencePriceLink.tsx
function FlightReferencePriceLink_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var FlightReferencePriceLink = function FlightReferencePriceLink(props) {
  var originName = props.originName,
      destinationName = props.destinationName,
      price = props.price,
      priceCurrency = props.priceCurrency,
      originId = props.originId,
      onClick = props.onClick;

  var onClickLink = function onClickLink(e) {
    e.preventDefault();
    onClick(originId);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
    onClick: onClickLink,
    css: linkStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: dataBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: destinationStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: textBlockStyle,
          children: originName
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: flightArrowStyle
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: textBlockStyle,
          children: destinationName
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: priceStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: labelStyle,
          children: "\u5F80\u5FA9"
        }), " ", (0,StringUtil/* numberToCurrency */.fe)(price, priceCurrency), " \u301C"]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: arrowBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: arrowStyle
      })
    })]
  });
};
var linkStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;cursor:pointer;background:#fff;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";box-sizing:border-box;margin:", spaceStyle/* space.atom */.D.atom, ";display:flex;transition:opacity 0.4s ease;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:calc(50% - ", spaceStyle/* space.atom2x */.D.atom2x, ");}&:hover{opacity:0.9;}" + ( true ? "" : 0),  true ? "" : 0);
var dataBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var destinationStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";flex:1;letter-spacing:0.1em;font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";display:flex;flex-wrap:wrap;align-items:center;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.body */.JB.body, ";}" + ( true ? "" : 0),  true ? "" : 0);
var priceStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";color:", colorStyle/* accentColor.secondaryColor */.z.secondaryColor, ";display:flex;align-items:center;" + ( true ? "" : 0),  true ? "" : 0);
var arrowBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";margin-left:auto;display:flex;align-items:center;border-left:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding:", spaceStyle/* space.atom2x */.D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var arrowStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("background:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";color:#fff;border-radius:50%;width:1.5rem;height:1.5rem;display:inline-block;position:relative;&:after{content:\"\";position:absolute;top:50%;left:46%;width:0.5rem;height:0.5rem;transform:translate(-50%, -50%) rotate(45deg);border:2px solid #fff;border-left:0;border-bottom:0;box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0);
var flightArrowStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;width:2.5rem;height:2px;margin:0 ", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 0 ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";background:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";&:after{content:\"\";position:absolute;top:50%;right:0;width:0.75rem;height:0.75rem;transform:translateY(-50%) rotate(45deg);border:2px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";border-left:0;border-bottom:0;box-sizing:border-box;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:3.5rem;}" + ( true ? "" : 0),  true ? "" : 0);
var labelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border:1px solid;font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";padding:0.0625rem 0.5rem;margin-right:", spaceStyle/* space.atom */.D.atom, ";margin-left:-", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";border-radius:", spaceStyle/* space.atom2x */.D.atom2x, ";font-weight:", typographyStyle/* fontWeight.regular */.Ue.regular, ";" + ( true ? "" : 0),  true ? "" : 0);
var textBlockStyle =  true ? {
  name: "1r5gb7q",
  styles: "display:inline-block"
} : 0;
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/flightDstRegion/components/FlightPriceList.tsx


















 // import {convertServerErrorToForm} from "main/javascripts/utils/FormUtil";




var dateFormat = "yyyy/LL/dd";
var FlightPriceList = function FlightPriceList(props) {
  var originName = props.originName,
      flightCheapestRoundTrips = props.flightCheapestRoundTrips;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var onClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(originId) {
      var today, departureDate, returnDate, targetFlightCheapest, traveler, params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              today = new Date();
              departureDate = (0,addMonths["default"])(today, 2);
              returnDate = (0,addDays["default"])(departureDate, 5);
              targetFlightCheapest = flightCheapestRoundTrips.find(function (flightCheapest) {
                return flightCheapest.originId === originId;
              });

              if (targetFlightCheapest) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              traveler = {
                number_of_adult: 2,
                number_of_children: 0
              };
              params = {
                origin_id: originId,
                origin: targetFlightCheapest.originName,
                origin_type: (0,lpFlightDstRegionSlice/* originTypeForSearch */.cb)(targetFlightCheapest),
                destination_id: targetFlightCheapest.destinationId,
                destination: targetFlightCheapest.destinationName,
                destination_type: (0,lpFlightDstRegionSlice/* destinationTypeForSearch */.Di)(targetFlightCheapest),
                cabin_class: "Y",
                departure_date: (0,format["default"])(departureDate, dateFormat),
                return_date: (0,format["default"])(returnDate, dateFormat),
                flight_type: FlightTypes/* FlightTypes.roundTrip */.z.roundTrip,
                traveler: traveler
              };
              return _context.abrupt("return", appDispatch((0,searchFlightSlice/* postSearchFlightCache */.re)({
                params: params
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,googleTagManagerUtil/* flightAvailabilitiesEvent */.t6)(cacheId, params);
                router.push("/flights?".concat((0,lib.stringify)(params, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId));
              })["catch"](function (errorResponse) {
                if (errorResponse.errors) {
                  // エラー形式を合わせるために変換している
                  // const errors = Object.keys(errorResponse.errors).map((key) => {
                  //   return { [key]: errorResponse.errors[key] };
                  // });
                  alert(t("form.submitError"));
                }
              }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  if (!flightCheapestRoundTrips || flightCheapestRoundTrips.length === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: FlightPriceList_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
      css: FlightPriceList_titleStyle,
      children: t("lp.flightReferencePriceListTitle", {
        destination: originName
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: linkBlockStyle,
      children: flightCheapestRoundTrips.map(function (data, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightReferencePriceLink, {
          originName: data.originName,
          originId: data.originId,
          destinationName: data.destinationName,
          price: data.priceCents,
          priceCurrency: data.priceCurrency,
          onClick: onClick
        }, index);
      })
    })]
  });
};
var FlightPriceList_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:0 auto ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var linkBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;justify-content:space-between;margin:", spaceStyle/* space.atom2x */.D.atom2x, " 0 0;background:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var FlightPriceList_titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";color:", colorStyle/* accentColor.secondaryColor2 */.z.secondaryColor2, ";padding:", spaceStyle/* space.atom */.D.atom, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";letter-spacing:0.1em;margin:0.5rem 0;position:relative;padding-bottom:", spaceStyle/* space.atom2x */.D.atom2x, ";&:before{content:\"\";position:absolute;bottom:0;display:block;height:1px;width:calc(100% - ", spaceStyle/* space.atom2x */.D.atom2x, ");background:#ddd;}&:after{content:\"\";position:absolute;bottom:0;display:block;height:1px;width:3rem;background:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Lp/BlockTitle/index.ts + 2 modules
var BlockTitle = __webpack_require__(7696);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var aphrodite_es = __webpack_require__(34397);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockSubTitle/BlockSubTitleStyle.ts






var BlockSubTitleStyle = aphrodite_es/* StyleSheet.create */.mM.create({
  block: {
    padding: spaceStyle/* space.atom */.D.atom
  },
  title: (0,defineProperty/* default */.Z)({
    fontSize: typographyStyle/* fontSize.subHeading */.JB.subHeading,
    lineHeight: typographyStyle/* lineHeight.mediumHeadline1 */.Nv.mediumHeadline1,
    color: colorStyle/* accentColor.secondaryColor2 */.z.secondaryColor2,
    padding: spaceStyle/* space.atom */.D.atom,
    margin: "0.5rem 0",
    letterSpacing: "0.1em"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading
  })
});
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockSubTitle/BlockSubTitle.tsx




var BlockSubTitle = function BlockSubTitle(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
    className: (0,aphrodite_es/* css */.iv)(BlockSubTitleStyle.title),
    children: props.children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Lp/BlockSubTitle/index.ts

// EXTERNAL MODULE: ./main/javascripts/components/atoms/Paragraph/index.ts
var Paragraph = __webpack_require__(10798);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Lp/RegionList/index.ts + 2 modules
var RegionList = __webpack_require__(93478);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Breadcrumb/index.ts + 2 modules
var Breadcrumb = __webpack_require__(99581);
// EXTERNAL MODULE: ./main/javascripts/components/chat/ChatEntry.tsx
var ChatEntry = __webpack_require__(35004);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/flightDstRegion/components/LpFlightDstRegionIndexMain.tsx
function LpFlightDstRegionIndexMain_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






















var LpFlightDstRegionIndexMain = function LpFlightDstRegionIndexMain() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var flightDestinationRegion = (0,store/* useAppSelector */.CG)(lpFlightDstRegionSlice/* flightDestinationRegionSelector */.oc);
  var breadcrumbData = [{
    url: "/",
    label: t("label:common.home")
  }];

  if (flightDestinationRegion) {
    if (flightDestinationRegion.country && flightDestinationRegion.region.regionType !== "country") {
      var country = flightDestinationRegion.country;
      breadcrumbData.push({
        url: "/lp/flights/dst_regions/".concat(country.code),
        label: country.name
      });
    }

    breadcrumbData.push({
      label: flightDestinationRegion.region.name
    });
  }

  var renderBreadcrumb = function renderBreadcrumb() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: breadcrumbBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: breadcrumbInnerStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* Breadcrumb */.a, {
          linkData: breadcrumbData
        })
      })
    });
  };

  var renderAccessToCity = function renderAccessToCity() {
    if (!flightDestinationRegion) {
      return null;
    }

    var region = flightDestinationRegion.region;

    if (region && region.airports && region.airports.findIndex(function (airport) {
      return !!airport.accessToCity;
    }) !== -1) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockTitle/* BlockTitle */.b, {
            children: t("lp.accessToCity")
          }), region.airports.map(function (airport, index) {
            return airport.accessToCity ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockSubTitle, {
                children: airport.shortName
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
                children: (0,StringUtil/* nl2br */.hU)(airport.accessToCity)
              })]
            }, index) : "";
          })]
        })
      });
    }

    return null;
  };

  var renderPriceList = function renderPriceList() {
    if (!flightDestinationRegion) {
      return null;
    }

    var regionName = flightDestinationRegion.region.name;
    var flightCheapestRoundTrips = flightDestinationRegion.flightCheapestRoundTrips;

    if (flightCheapestRoundTrips && flightCheapestRoundTrips.length > 0) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: priceListBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightPriceList, {
            originName: regionName,
            flightCheapestRoundTrips: flightCheapestRoundTrips
          })
        })
      });
    }

    return null;
  };

  var renderDescription = function renderDescription() {
    if (!flightDestinationRegion) {
      return null;
    }

    var regionName = flightDestinationRegion.region.name;

    if (flightDestinationRegion.region.description) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockTitle/* BlockTitle */.b, {
          children: t("lp.destinationAbout", {
            destination: regionName
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
          children: (0,StringUtil/* nl2br */.hU)(flightDestinationRegion.region.description)
        })]
      });
    }

    return null;
  };

  var renderBestSeason = function renderBestSeason() {
    if (!flightDestinationRegion) {
      return null;
    }

    var regionName = flightDestinationRegion.region.name;

    if (flightDestinationRegion.region.bestSeason) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockSubTitle, {
          children: t("lp.destinationBestSeason", {
            destination: regionName
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
          children: (0,StringUtil/* nl2br */.hU)(flightDestinationRegion.region.bestSeason)
        })]
      });
    }

    return null;
  };

  var renderComment = function renderComment() {
    if (!flightDestinationRegion) {
      return null;
    }

    if (flightDestinationRegion.region.comment) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockSubTitle, {
          children: t("lp.conciergeComment")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
          children: (0,StringUtil/* nl2br */.hU)(flightDestinationRegion.region.comment)
        })]
      });
    }

    return null;
  };

  var renderMainAirline = function renderMainAirline() {
    if (!flightDestinationRegion) {
      return null;
    }

    var regionName = flightDestinationRegion.region.name;

    if (flightDestinationRegion.region.mainAirline) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockTitle/* BlockTitle */.b, {
            children: t("lp.destinationMainAirlines", {
              destination: regionName
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
            children: (0,StringUtil/* nl2br */.hU)(flightDestinationRegion.region.mainAirline)
          })]
        })
      });
    }

    return null;
  };

  var renderSurroundingRegions = function renderSurroundingRegions() {
    if (!flightDestinationRegion) {
      return null;
    }

    if (flightDestinationRegion.surroundingRegions) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockTitle/* BlockTitle */.b, {
            children: t("lp.surroundingRegions")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionList/* RegionList */.Y, {
            regions: flightDestinationRegion.surroundingRegions,
            linkUrl: "/lp/flights/dst_regions/"
          })]
        })
      });
    }

    return null;
  };

  if (!flightDestinationRegion) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(block_MainBlock/* MainBlock */.R, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: LpFlightDstRegionIndexMain_blockStyle,
      children: [renderBreadcrumb(), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("article", {
        children: [renderPriceList(), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: infoBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
            children: [renderDescription(), renderBestSeason(), renderComment()]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
          styleKey: "blockWide",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
            css: chatEntryBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChatEntry/* ChatEntry */.o, {})
          })
        }), renderAccessToCity(), renderMainAirline(), renderSurroundingRegions()]
      })]
    })
  });
};
var LpFlightDstRegionIndexMain_blockStyle =  true ? {
  name: "8cz73a",
  styles: "padding:0 0 3rem"
} : 0;
var infoBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var chatEntryBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin-left:", spaceStyle/* space.atom */.D.atom, ";margin-right:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var priceListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";max-width:100%;box-sizing:border-box;background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbInnerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, ";box-sizing:border-box;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";border-left:0;border-right:0;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/footer/Footer.tsx
var Footer = __webpack_require__(77747);
;// CONCATENATED MODULE: ./pages/lp/flights/dst_regions/[regionId].tsx





















// loadVConsole(2000);
function FlightDstRegionsShow(props) {
  var flightDestinationRegion = props.flightDestinationRegion,
      _props$metaTags = props.metaTags,
      metaTags = _props$metaTags === void 0 ? {} : _props$metaTags,
      locale = props.locale;
  var title = metaTags.title,
      description = metaTags.description,
      noindex = metaTags.noindex;
  var origin = Constants/* HOST */.M5;
  (0,useConstructor/* useConstructor */.g)(function () {
    if (flightDestinationRegion) {
      store/* store.dispatch */.h.dispatch((0,lpFlightDstRegionSlice/* initFlightDestination */.O4)({
        flightDestinationRegion: flightDestinationRegion,
        metaTags: metaTags
      }));
    }

    if (i18n/* default.language */.Z.language !== locale) {
      void i18n/* default.changeLanguage */.Z.changeLanguage(locale);
    }

    globalStyle/* extended.css */.bU.css(globalStyle/* defaultStyles */.jF[globalStyle/* GLOBALS */.UH]);
  });
  (0,useUserAccount/* useUserAccount */.q)(store/* store */.h);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(es/* Provider */.zt, {
    store: store/* store */.h,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainHead/* MainHead */.I, {
      origin: origin,
      title: title,
      description: description,
      noindex: !!noindex
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(I18nextProvider/* I18nextProvider */.a, {
      i18n: i18n/* default */.Z,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer/* HeaderContainer */.g, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainBlock/* MainBlock */.R, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBlock/* SearchBlock */.w, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFlight, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpFlightDstRegionIndexMain, {})]
        }, 1), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* Footer */.$, {})]
      })
    })]
  });
}

var __N_SSG = true;
/* harmony default export */ var _regionId_ = (FlightDstRegionsShow);

/***/ }),

/***/ 81248:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/flights/dst_regions/[regionId]",
      function () {
        return __webpack_require__(76438);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8053,9481,9113,5057,1906,2912,9923,4170,4602,2802,853,7744,8808,7886,4349,6129,8740,9918,5147,4750,1185,5567,5284,6852,5543,2582,9938,2867,652,5624,9774,2888,179], function() { return __webpack_exec__(81248); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);